import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-cuota-inicial',
  templateUrl: './cuota-inicial.component.html',
  styleUrls: ['./cuota-inicial.component.scss'],
})
export class CuotaInicialComponent implements OnInit {
   Datos = []
   @Input() UserID =""
   todo=false;
    @Input() Hijos = []
  @Output() desabilitar = new EventEmitter();
  disabled: boolean=true;
  
  constructor( private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) { }

  ngOnInit() {
    setTimeout(() => {
      this.todo=true;
      this.getCuotaInicialMisEstudiantes()
    }, 100);
  }


  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 130) {
        return true;
      }
    }
    return false;
  }


  getCuotaInicialMisEstudiantes() {
    this.utilidades.Loading("Cargando documentos")
    this.conexion.getCuotaInicialMisEstudiantes(this.UserID).subscribe((resp) => {
      this.desabilitar.emit(false)
      this.disabled=false;
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        this.Datos = resp.Datos
        this.utilidades.Depuracion(resp.Datos, "console", "")
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
      this.desabilitar.emit(true)
      this.disabled=true;
      this.utilidades.ValidarUser(err)
    })
  }


  Sumar(){
    let total = 0;
    for(let i of this.Datos){
      total += Number(i.MontoInscripcion)
    }

    return total;
  }

  getFoto(idestudiante){
    for(let i of this.Hijos){
      if(i.Id==idestudiante){
        return i.Url
      }
    }
    return ""
  }
}
